/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDoctorDto } from '../../models/create-doctor-dto';
import { ResponseDoctorDto } from '../../models/response-doctor-dto';

export interface DoctorsControllerCreate$Params {
      body: CreateDoctorDto
}

export function doctorsControllerCreate(http: HttpClient, rootUrl: string, params: DoctorsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDoctorDto>> {
  const rb = new RequestBuilder(rootUrl, doctorsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDoctorDto>;
    })
  );
}

doctorsControllerCreate.PATH = '/thalea-doctors/doctors';
